module.exports = __webpack_public_path__ + "img/09.abca3d67.jpg";